import facilitymanagement from "./views/facilitymanagement.vue";
import facilitydetail from "./views/facilitydetail.vue";
import facilitydash from "./views/facilitydash.vue";
import facilitydashmaintenance from "./views/facilitydashmaintenance.vue";
import facilitydashengineering from "./views/facilitydashengineering.vue";
import facilitydashreport from "./views/facilitydashreport.vue";
import facilitydashoperations from "./views/facilitydashoperations.vue";
import facilitydashviewvendor from "./views/facilitydashviewvendor.vue";
import facilitydashviewcontractor from "./views/facilitydashviewcontractor.vue";
import facilitydashviewintegrated from "./views/facilitydashviewintegrated.vue";

const routes = [
  {
    path: "/facilitydash",
    name: "facilitydash",
    component: facilitydash
  },
  {
    path: "/facilitydashoperations",
    name: "facilitydashoperations",
    component: facilitydashoperations
  },
  {
    path: "/facilitydashmaintenance",
    name: "facilitydashmaintenance",
    component: facilitydashmaintenance
  },
  {
    path: "/facilitydashengineering",
    name: "facilitydashengineering",
    component: facilitydashengineering
  },
  {
    path: "/facilitydashreport",
    name: "facilitydashreport",
    component: facilitydashreport
  },
  {
    path: "/facilitydashviewvendor",
    name: "facilitydashviewvendor",
    component: facilitydashviewvendor
  },
  {
    path: "/facilitydashviewintegrated",
    name: "facilitydashviewintegrated",
    component: facilitydashviewintegrated
  },
  {
    path: "/facilitydashviewcontractor",
    name: "facilitydashviewcontractor",
    component: facilitydashviewcontractor
  },
  {
    path: "/facilitydetail",
    name: "facilitydetail",
    component: facilitydetail
  },
  {
    path: "/facilitymanagement",
    name: "facilitymanagement",
    component: facilitymanagement
  }
];

export default routes;
